import { Component, OnInit } from '@angular/core';
import { Constants } from '../../shared/common/helper/constants';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'reports-layout',
  templateUrl: './reports-layout.component.html',
  styleUrls: ['./reports-layout.component.scss'],
})
export class ReportsLayoutComponent implements OnInit {
  constants = Constants;
  selectedPanel = 'department';

  constructor(private router: Router) {}

  ngOnInit() {
    this.onRouteChange();

    this.setActivePanel(this.router.url);
  }

  onRouteChange() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.setActivePanel(event.url);
      }
    });
  }

  setActivePanel(url) {
    if (url.indexOf('/reports/team') > -1) {
      this.selectedPanel = 'team';
    } else if (url.indexOf('/reports/backlog') > -1) {
      this.selectedPanel = 'backlog';
    } else if (url.indexOf('/reports/custom') > -1) {
      this.selectedPanel = 'custom';
    } else {
      this.selectedPanel = 'department';
    }
  }
}
